/** Only the Simulation and its Academy/Desk can use the owner's local preview. */
export function isSimulationPracticePath(pathname: string): boolean {
  return ["/sim", "/simulation", "/academy", "/desk"].some(
    (root) => pathname === root || pathname.startsWith(`${root}/`),
  );
}

export function practiceAllowed(isAdmin: boolean, enabled: boolean, pathname: string): boolean {
  return isAdmin && enabled && isSimulationPracticePath(pathname);
}